module.exports = __webpack_public_path__ + "static/media/west-campus.ef789416.webp";